import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction, changeRegModeAction } from "../../redux/app/actions";
import { changeDsAction, addCatAction, delCatAction, changeCatNameAction, changeCatSelRowAction } from "../../redux/boring/actions";
import { openSwAction } from "../../redux/ui/actions";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        swMode: state.appReducer.swMode,
        ds: state.boringReducer.dataset,
        catData: state.boringReducer.catData,
    };
};

class Cat extends Component {
    /*★ここから公開版で削除*/
    //    constructor(props) {
    //        super(props);
    //        this.selRow = null;
    //        this.isDel = false;
    //        this.closeSw = this.closeSw.bind(this);
    //        this.addCat = this.addCat.bind(this);
    //        this.delCat = this.delCat.bind(this);
    //        this.changeCatName = this.changeCatName.bind(this);
    //        this.changeRow = this.changeRow.bind(this);
    //    }
    //
    //    componentDidUpdate(prevProps) {
    //        /*
    //         * 削除時catDataのID、datasetのcatを修正
    //         * @since hara 2020-10-20
    //         */
    //        if(prevProps.catData !== this.props.catData && this.isDel) {
    //            const catData = [...this.props.catData];
    //            catData.forEach((el, index) => {
    //                el.ID = index + 1;
    //            });
    //            this.props.dispatch(changeCatNameAction(catData));
    //
    //            const ds = [...this.props.ds];
    //            ds.forEach(el => {
    //                if (el.cat === parseInt(this.selRow) - 1) {//削除catの場合未設定にする
    //                    el.cat = 0;
    //                } else if (parseInt(this.selRow) - 1 < el.cat) {//削除catより大きい場合1小さくする
    //                    el.cat = el.cat - 1;
    //                }
    //            });
    //            this.props.dispatch(changeDsAction(ds));
    //
    //            this.isDel = false;
    //            this.selRow = null;
    //        }
    //    }
    //
    //    /*
    //     * 分類追加
    //     * @since hara 2020-10-20
    //     */
    //    addCat() {
    //        this.props.dispatch(addCatAction(Object.keys(this.props.catData).length + 1));
    //    }
    //
    //    /*
    //     * 分類削除
    //     * @since hara 2020-10-20
    //     */
    //    delCat() {
    //        if (parseInt(this.selRow) <= 1) {
    //            alert('既存分類は削除できません。');
    //        } else if (this.selRow !== null) {
    //            this.props.dispatch(delCatAction(parseInt(this.selRow)));
    //            this.isDel = true;
    //        }
    //    }
    //
    //    /*
    //     * 分類名称変更
    //     * @param {Number} index フィールドの行インデックス
    //     * @param {Event} e イベント情報
    //     * @since hara 2020-10-20
    //     */
    //    changeCatName(index, e) {
    //        const catData = [...this.props.catData];
    //        catData[index] = {...catData[index], 'name': e.target.value};
    //
    //        this.props.dispatch(changeCatNameAction(catData));
    //    }
    //
    //    /*
    //     * テーブル選択
    //     * @param {Event} e イベント情報
    //     * @since hara 2020-09-09
    //     */
    //    changeRow(e) {
    //        e.target.closest('tbody').childNodes.forEach(el => {
    //            el.classList.remove('selRow');
    //        });
    //        const tr = e.target.closest('tr');
    //        tr.classList.add('selRow');
    //        this.selRow = tr.id;
    //
    //        this.props.dispatch(changeCatSelRowAction(this.selRow));
    //    }
    //
    //    /*
    //     * サブウィンドウを閉じる
    //     * @since hara 2020-09-09
    //     */
    //    closeSw() {
    //        this.props.dispatch(openSwAction('boring'));
    //    }

    render() {
        return {
            /*
            <Sw title='ボーリング分類'>
                <div className='btnWrap'>
                    <button className='sBtn' onClick={this.addCat}>追加</button>
                    <button className='sBtn l-mlS' onClick={this.delCat}>削除</button>
                </div>

                <div className='TWrap l-mtS js-scroll' style={{overflowY: 'scroll'}}>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th className='tsS'>ID</th>
                                <th>分類名称</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.catData.map((el, index) => (
                                <tr id={el.ID} key={el.ID} onClick={this.changeRow}>
                                    <td>{el.ID}</td>
                                    <td><input className='textT' type='text' value={el.name} onChange={e => this.changeCatName(index, e)} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='l-right l-mtM'>
                    <button className='cBtn l-mlS' onClick={this.closeSw}>閉じる</button>
                </div>
            </Sw>
            */
        };
    }
    /*★ここまで公開版で削除*/
}

export default connect(mapStateToProps)(Cat);
